import Chart from 'chart.js/auto'

$(document).on('turbolinks:load', () => {
  var json = $('#params').data('chart-json')
  if (json != null) {
    var chart = new Chart($("#stage"), json)
  }
})

// // プラグインの登録
// addPlugin = (json) => {
//   if (json['plugins'] == null) {
//     return json
//   }
    
//   // Define a plugin to provide data labels
//   // https://beiznotes.org/data-label-on-chart-js/
//   dataLabelPlugin = {
//     afterDatasetsDraw: (chart, easing) => {
//       // To only draw at the end of animation, check for easing === 1
//       ctx = chart.ctx;

//       chart.data.datasets.each((i, dataset) => {
//         meta = chart.getDatasetMeta(i);
//         if (!meta.hidden) {
//           meta.data.each((index) => {
//             if (dataset.data[index] == 0) {
//               return true
//             }
//             // Draw the text in black, with the specified font
//             ctx.fillStyle = 'rgb(0, 0, 0)'

//             fontSize = 14
//             fontStyle = 'normal'
//             fontFamily = 'Helvetica Neue'
//             ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

//             // Just naively convert to string for now
//             dataString = dataset.data[index].toString()

//             // Make sure alignment settings are correct
//             ctx.textAlign = 'center'
//             ctx.textBaseline = 'middle'

//             position = element.getCenterPoint()
//             ctx.fillText(dataString, position.x, position.y)
//           })
//         }
//       })
//     }
//   }

//   json['plugins'].each((i, plugin) => {
//     if (plugin == 'dataLabelPlugin'){
//       json['plugins'][i] = dataLabelPlugin
//     }
//   })

//   return json
// }
